import * as React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { ApplicationState } from "../../..";
import { Language } from "../../../data/constants";
import { SessionState } from "../../../store/session/SessionState";
import { de } from "../../../translations/de";
import { en } from "../../../translations/en";
import { fr } from "../../../translations/fr";
import { it } from "../../../translations/it";

type LanguageProviderProps = SessionState;

const localizedMessages = {
  [Language.DE]: de,
  [Language.EN]: en,
  [Language.FR]: fr,
  [Language.IT]: it,
};

const LanguageProvider: React.FC<LanguageProviderProps> = ({ children, language }) => {
  return (
    <IntlProvider locale={language} messages={localizedMessages[language]}>
      {children}
    </IntlProvider>
  );
};

export default connect((state: ApplicationState) => state.sessionState)(LanguageProvider);
